import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { AfterViewChecked, AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup} from '@angular/forms';
import * as moment from 'moment';
import { SortEnum } from 'src/app/utils/enums/sort-enum';
import { Paginated } from 'src/app/utils/interfaces/new/paginated.interface';

@Component({
  selector: 'frg-table',
  templateUrl: './table.fragment.html',
  styleUrls: ['./table.fragment.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class TableFragment implements OnInit, AfterViewInit, OnChanges, AfterViewChecked {

  @ViewChild('table') public tableElementRef: ElementRef;
  @ViewChild('buttonHeader') public buttonHeaderElementRef: ElementRef;
  @ViewChild('newItem') public newItemElementRef: ElementRef;

  @Input() public id: string;
  @Input() public idSource: string;
  @Input() public idDropTable: string;
  @Input() public idConnectedTable: string;
  @Input() public keysBody: Paginated<any>;
  @Input() public keysColumn: any[];
  @Input() public tableButton1: string;
  @Input() public tableButton1Tooltip: string;
  @Input() public tableButton2: string;
  @Input() public tableButton2Tooltip: string;
  @Input() public tableButton3: string;
  @Input() public tableButton3Tooltip: string;
  @Input() public tableButton4: string;
  @Input() public tableButton4Tooltip: string;
  @Input() public tableButton5: string;
  @Input() public tableButton5Tooltip: string;
  
  @Input() public tableButtonHeader: string;
  @Input() public tableButtonNewItem: string;
  @Input() public loading = false;
  @Input() public isEdit = false;
  @Input() public dragDrop = false;
  @Input() public deleteDuringEdit: boolean = false;
  @Input() public isRowsClickable: boolean = false;
  @Input() public isOkForDblClick: boolean = false;
  @Input() public isCenterHeader: boolean = false;
  @Input() public showFormButton: boolean = true;
  @Output() public formSubmit = new EventEmitter();
  @Output() public formCancel = new EventEmitter();

  @Input() dropdownItems: object[] = [];
  public nbClicks = 0;
  public newItems = [];
  public changelog = [];
  public sortBy;
  public sortOrder;
  public selectedLabels = [];
  public regexDate = '^(?:(?:31(\\/|-|\\.)(?:0?[13578]|1[02]))\\1|(?:(?:29|30)(\\/|-|\\.)(?:0?[13-9]|1[0-2])\\2))(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$|^(?:29(\\/|-|\\.)0?2\\3(?:(?:(?:1[6-9]|[2-9]\\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\\d|2[0-8])(\\/|-|\\.)(?:(?:0?[1-9])|(?:1[0-2]))\\4(?:(?:1[6-9]|[2-9]\\d)?\\d{2})$';

  public form: FormGroup;

  // Mettre un listener sur la valeur Search.
  // Quand elle change, remettre la page à 1.

  public page = 1;

  @Output() public onClick1 = new EventEmitter();
  @Output() public onClick2 = new EventEmitter();
  @Output() public onClick3 = new EventEmitter();
  @Output() public onClick4 = new EventEmitter();
  @Output() public onHover5 = new EventEmitter();
  
  @Output() public onClickHeader = new EventEmitter();
  @Output() public onChangePage = new EventEmitter();
  @Output() public onClickRow = new EventEmitter();
  @Output() public onDblClickRow = new EventEmitter();
  @Output() public onSort = new EventEmitter();
  @Output() public onDropSame = new EventEmitter();
  @Output() public onDropDifferent = new EventEmitter();
  @Output() public editMode = new EventEmitter();

  constructor(
    public formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
  }


  public ngAfterViewInit(): void {
    // Hauteur du header + hauteur de la bordure de chaque item (dernier item aucune bordure) + hauteur de tous les items
    // if (this.keysBody.objects.length > this.keysBody.perpage) {
    //   this.tableElementRef.nativeElement.style.minHeight = 32 + (this.numberItemPerPage - 1) + (this.numberItemPerPage * 46) + 'px';
    // }
    // this._initButtonsIcon();
  }

  public ngAfterViewChecked(): void {
    if (this.buttonHeaderElementRef && !this.buttonHeaderElementRef.nativeElement.style.backgroundImage) {
      this.buttonHeaderElementRef.nativeElement.style.backgroundImage = `url(${this.tableButtonHeader})`;
      this.buttonHeaderElementRef.nativeElement.style.backgroundSize = "90%";
      this.buttonHeaderElementRef.nativeElement.style.backgroundRepeat = "no-repeat";
      this.buttonHeaderElementRef.nativeElement.style.backgroundPosition = "center";
    }
    if (this.newItemElementRef && !this.newItemElementRef.nativeElement.style.backgroundImage) {
      this.newItemElementRef.nativeElement.style.backgroundImage = `url(${this.tableButtonNewItem})`;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.keysColumn && this.keysBody) {
      this.initForm();
    }
  }

  public toggleEditMode(): void {
    this.isEdit = !this.isEdit;
    if (this.isEdit) {
      if (!this.form) {
        this.initForm();
      }
    } else {
      this.newItems = [];
      this.changelog = [];
      this.form = null;
      this.initForm();
      this.formCancel.emit();
    }
    this.editMode.emit(this.isEdit);
  }

  public initForm(): void {
    if (this.isEdit) {
      const formGroup = {};
      // Keysbody = les objets reçu
      for (const keyBody of this.keysBody.objects) {
        // KeysColumn = les attributs à vérifier
        for (const keyColumn of this.filterData(this.keysColumn)) {
          if (keyColumn.editType) {
            let formControl;
            if (keyColumn.editType === 'date') {
              formControl = this.formBuilder.control(
                keyBody[keyColumn.data] ? moment(keyBody[keyColumn.data]).format('YYYY-MM-DD') : null
              );
            } else if (keyColumn.validators) {
              formControl = this.formBuilder.control(keyBody[keyColumn.data], keyColumn.validators);
            } else {
              formControl = this.formBuilder.control(keyBody[keyColumn.data]);
            }
            formGroup[`${keyBody.id}${keyColumn.data}`] = formControl;
          }
        }
      }
      this.form = this.formBuilder.group(formGroup);
    }
  }

  public addToChangeLog(keyBody: any): void {
    const already = keyBody && keyBody.id ? this.changelog.find((id) => id === keyBody.id) : undefined;
    if (!already && keyBody && keyBody.id) {
      this.changelog.push(keyBody.id);
    }
  }

  public addNewItem(idSource?: string): void {
    let canAddNewItem = true;
    const newItem = {};
    newItem['id'] = `_create${this.newItems.length}`;
    for (const keyColumn of this.filterData(this.keysColumn)) {
      let control;
      if (keyColumn.validators) {
        control = this.formBuilder.control('', keyColumn.validators);
      } else {
        control = this.formBuilder.control('');
      }
      if (keyColumn.title === "Source") {
        control = this.formBuilder.control(idSource);
      }
      if (keyColumn.defaultValue && keyColumn.defaultValue !== '') {
        control = this.formBuilder.control(keyColumn.defaultValue);
      }
      this.form.addControl(`${newItem['id']}${keyColumn.data}`, control);

      /**
       * On détermine si la ligne précédente est valid
       *
       * Si ce n'est pas le cas :
       * - 'canAddNewItem' passe à false
       * - on utilise la méthode 'markAsTouched' pour afficher le message d'erreur dans le formulaire
       */
      if (this.newItems.length > 0
        && !this.form.get(`_create${Number(newItem['id'].split('_create')[1]) - 1}${keyColumn.data}`).valid) {
        canAddNewItem = false;
        this.form.get(`_create${Number(newItem['id'].split('_create')[1]) - 1}${keyColumn.data}`).markAsTouched();
        break;
      }

    }

    // Si 'canAddNewItem' est false alors on ajoute pas la ligne
    if (canAddNewItem) {
      this.newItems.push(newItem);
    }
  }

  public async onSubmit(): Promise<void> {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      const changes = [];
      for (let id of this.changelog) {
        const item = {};
        item['id'] = id;
        for (const keyColumn of this.filterData(this.keysColumn)) {
          if (keyColumn.isEditable) {
            if (keyColumn.editType === 'date') {
              if (this.form.get(`${id}${keyColumn.data}`).value && this.form.get(`${id}${keyColumn.data}`).value !== '' && this.form.get(`${id}${keyColumn.data}`).value !== null) {
                item[`${keyColumn.data}`] = moment(this.form.get(`${id}${keyColumn.data}`).value).format("YYYY-MM-DD");
              } else {
                item[`${keyColumn.data}`] = undefined;
              }
            } else {
              item[`${keyColumn.data}`] = this.form.get(`${id}${keyColumn.data}`).value;
            }
          }
        }
        changes.push(item);
      }
      this.formSubmit.emit(changes);
      this.newItems = [];
      this.changelog = [];
    }
  }

  public sort(event): void {
    if (event.data) {
      this.sortBy = event.data;
      this.sortOrder && this.sortOrder === SortEnum.ASC ? this.sortOrder = SortEnum.DESC : this.sortOrder = SortEnum.ASC;
      const emit = {
        sortOrder: this.sortOrder,
        sortBy: event.data
      };
      this.onSort.emit(emit);
    }
  }

  public onChangedPage(event): void {
    this.onChangePage.emit(event);
  }

  public onClick1Active(value: any): void {
    if (!value.cantDelete) {
      this.onClick1.emit(value);
      
    }
  }

  public onClick2Active(value: any): void {
    if (!value.cantEdit) {
      this.onClick2.emit(value);
    }
  }

  public onClick3Active(value: any): void {
    if (!value.cantEdit) {
      this.onClick3.emit(value);
    }
  }
  public onClick4Active(value: any): void {
    if (!value.cantEdit) {
      this.onClick4.emit(value);
    }
  }

//stocke le contenu de l'infobulle
public currentTooltip  = ''


//assigne une valeur à getToolTip au hover du tableButton5
public onHover5Active(value: any): void {
    this.currentTooltip = this.getTooltipContent(value)
}
 //moreInfoBubble est utilisé pour récupérer des données à afficher dans plusieurs tableaux (documents patient: ordonnances, courriers, documents)
moreInfosBubble: {title:string , content:string}[]= [
    { title: 'Date création', content: "createdAt"},
    { title: 'Date modification', content: "upDatedAt"},
    { title: 'Type consultation', content: "consultationType"},
    {title:'CDA type' , content : "cdaType"},
    {title:'CDA date' , content :"cdaDate"},
    {title:'Auteur' , content: "author"}, //author pour historique imagerie et authorName pour historique courrier
    { title: 'Auteur', content: 'authorName' },
    { title: 'N° e-Prescription', content: 'eprescription'},
    { title: 'Type e-Prescription', content: 'typeEprescription'}

]


//Filtre les contents "undefined", itère dans moreInfoBubble et crée la chaine de caractères qui sera contenue dans getToolTip au hover.
private getTooltipContent(keyBody: any): string {
  return this.moreInfosBubble
    .filter(item => keyBody[item.content] !== undefined) 
    .map(item => `${item.title}: ${keyBody[item.content]}`) 
    .join('\n');
}
 

  public onClickRowActive(value: any): void {
    if (this.isRowsClickable) {
      if (this.isOkForDblClick) {
        this.nbClicks++;
        if (this.nbClicks > 1) {
          this.onDblClickRow.emit(value);
        } else {
          setTimeout(() => {
            if (this.nbClicks === 1) {
              this.onClickRow.emit(value);
            }
            this.nbClicks = 0;
          }, 500);
        }
      } else {
        this.onClickRow.emit(value);
      }
    }

  }

  public onClickButtonHeader(): void {
    this.onClickHeader.emit();
  }

  public filterData(columnOptions: any[]): any[] {
    const filteredColumnOptions = columnOptions.filter(elem => elem.data != null);
    return filteredColumnOptions;
  }

  public dropped(event: CdkDragDrop<string[]>): void {
    if (event.container.id === event.previousContainer.id) {
      // move inside same list
      this.onDropSame.emit(event);
    } else {
      // move between lists
      this.onDropDifferent.emit(event);
    }
  }

  public formatData(obj: any, arg: any): string {
    if (arg.isEditable && (arg.editType === "ngSelect" || arg.editType === "multiple")) {
      let result = '';
      if (Array.isArray(obj)) {
        for (let id of obj) {
          result += arg.editValue.find(x => x.id === id).libelle + ', ';
        }
      } else {
        const value = arg.editValue.find(x => x.id === obj);
        if (value) {
          result = value.libelle;
        }
      }
      return result;
    }
    if (arg.data.toLowerCase().includes('date') && obj && moment(obj).isValid()) {
      return moment(obj).format('DD/MM/YYYY');
    } else {
      if (arg.isCellColor) {
        return '';
      }
      return obj;
    }
  }

  public hexToRgba(hex: string, opacity = '0.5') {
    let color: any;
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
      color = hex.substring(1).split('');
      if (color.length == 3) {
        color = [color[0], color[0], color[1], color[1], color[2], color[2]];
      }
      color = '0x' + color.join('');
      return 'rgba(' + [(color >> 16) & 255, (color >> 8) & 255, color & 255].join(',') + `,${opacity})`;
    } else {
      return hex.split('#')[1];
    }
    // throw new Error('Bad Hex');
  }

  public getTHClass(index: number, keyColumn: any) {
    let classes = {
      'center-item': ((this.tableButton1 && this.tableButton2 && this.tableButton3 && this.tableButton4 && this.tableButton5) && (this.keysColumn.length - 1 === index || this.keysColumn.length - 2 === index || this.keysColumn.length - 3 === index || this.keysColumn.length - 4 === index || this.keysColumn.length - 5 === index)) || (this.tableButton1 || this.tableButton2 || this.tableButton3 || this.tableButton4 || this.tableButton5) && (this.keysColumn.length - 1 === index)    };

    if (!this.isEdit) {
      classes['clickable'] = keyColumn.data;
      classes['align-left'] = !this.isCenterHeader;
    }

    if (keyColumn.cssClass) {
      classes[keyColumn.cssClass] = true;
    }

    return classes;
  }

  public getButton1Icon(iconUri: string | undefined): string {
    if (iconUri) {
      return iconUri;
    } else {
      return this.tableButton1;
    }
  }

  public getButton2Icon(iconUri: string | undefined): string {
    if (iconUri) {
      return iconUri;
    } else {
      return this.tableButton2;
    }
  }

  public getButton3Icon(iconUri: string | undefined): string {
    if (iconUri) {
      return iconUri;
    } else {
      return this.tableButton3;
    }
  }
  public getButton4Icon(iconUri: string | undefined): string {
    if (iconUri) {
      return iconUri;
    } else {
      return this.tableButton4;
    }
  }

  public getButton5Icon(iconUri: string | undefined): string {
    if (iconUri) {
      return iconUri;
    } else {
      return this.tableButton5;
    }
  }

  public getTooltip(mainMessage: string | undefined, targetMessage: string | undefined): string {
    if (targetMessage) {
      return targetMessage;
    } else if (mainMessage) {
      return mainMessage;
    } else {
      return '';
    }
  }
}
